import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService 
  ) {}

  getApplicationsByCustomerCode(code: string): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetApplicationsByCustomerCode/${code}`;

    return this.http.get<any>(url, { headers: this.headerHelperService.getHeaders() });
  }
}
